interface StudyContent {
  value: string;
  description: string | JSX.Element;
}

interface StudySection {
  title: string;
  content: StudyContent[];
}

type TranslationOptions = { returnObjects: boolean };

type TranslationFunction = {
  (key: string): string;
  (key: string, options: TranslationOptions): string[];
};

const ns = 'FaqContent.';

const getFullFaq = (t: TranslationFunction): StudySection[] => {
  const supportMail = process.env['NX_SENDGRID_EMAIL_FROM'];

  return [
    {
      title: t(`${ns}Section1.Title`),
      content: [
        {
          value: t(`${ns}Section1.Contents1.Title`),
          description: (
            <span>
              {t(`${ns}Section1.Contents1.Content.Description`)}
              <ul>
                {(
                  t(`${ns}Section1.Contents1.Content.Points`, {
                    returnObjects: true,
                  }) as string[]
                ).map((point: string, index: number) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </span>
          ),
        },
        {
          value: t(`${ns}Section1.Contents2.Title`),
          description: (
            <span>
              {t(`${ns}Section1.Contents2.Content.Description1`)}
              <ul>
                {(
                  t(`${ns}Section1.Contents2.Content.Points`, {
                    returnObjects: true,
                  }) as string[]
                ).map((point: string, index: number) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
              {t(`${ns}Section1.Contents2.Content.Description2`)}
              <br /> <br />
              {t(`${ns}Section1.Contents2.Content.Description3`)}
            </span>
          ),
        },
        {
          value: t(`${ns}Section1.Contents3.Title`),
          description: (
            <span>
              {t(`${ns}Section1.Contents3.Content.Description1`)}
              <br />
              <br />
              {t(`${ns}Section1.Contents3.Content.Description2`)}
              <br />
              <br />
              {t(`${ns}Section1.Contents3.Content.Description3`)}
            </span>
          ),
        },
        {
          value: t(`${ns}Section1.Contents4.Title`),
          description: (
            <span>
              {t(`${ns}Section1.Contents4.Content.Description1`)}
              <strong>
                {' '}
                {t(`${ns}Section1.Contents4.Content.Description2`)}{' '}
              </strong>
              {t(`${ns}Section1.Contents4.Content.Description3`)}
              <br /> <br />
              {t(`${ns}Section1.Contents4.Content.Description4`)}
              <br /> <br />
              {t(`${ns}Section1.Contents4.Content.Description5`)}
              <strong>
                {' '}
                {t(`${ns}Section1.Contents4.Content.Description6`)}
              </strong>
              .
            </span>
          ),
        },
        {
          value: t(`${ns}Section1.Contents5.Title`),
          description: (
            <div>
              <p>{t(`${ns}Section1.Contents5.Content.Description1`)}</p>
              <ul>
                {(
                  t(`${ns}Section1.Contents5.Content.Points1`, {
                    returnObjects: true,
                  }) as string[]
                ).map((point: string, index: number) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
              <p>{t(`${ns}Section1.Contents5.Content.Description2`)}</p>
              <ul>
                {(
                  t(`${ns}Section1.Contents5.Content.Points2`, {
                    returnObjects: true,
                  }) as string[]
                ).map((point: string, index: number) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
          ),
        },
        {
          value: t(`${ns}Section1.Contents6.Title`),
          description: (
            <div id="teilnehmende gemeinden">
              {/* // id has to stay the same! */}
              <p>{t(`${ns}Section1.Contents6.Content.Description`)}</p>
              <ul>
                {(
                  t(`${ns}Section1.Contents6.Content.Points`, {
                    returnObjects: true,
                  }) as string[]
                ).map((point: string, index: number) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </div>
          ),
        },
        {
          value: t(`${ns}Section1.Contents8.Title`),
          description: (
            <div>
              {t(`${ns}Section1.Contents8.Content.Description1`)}{' '}
              <strong>{t(`${ns}Section1.Contents8.Content.BoldText1`)}</strong>{' '}
              {t(`${ns}Section1.Contents8.Content.Description2`)}
              <strong> {t(`${ns}Section1.Contents8.Content.BoldText2`)}</strong>
              {t(`${ns}Section1.Contents8.Content.Description3`)}
            </div>
          ),
        },
        {
          value: t(`${ns}Section1.Contents9.Title`),
          description: (
            <div>
              {t(`${ns}Section1.Contents9.Content.Description1`)}{' '}
              <a href="https://www.swisscannabis-research.ch">
                www.swisscannabis-research.ch
              </a>
              <br /> {t(`${ns}Section1.Contents9.Content.Description2`)}{' '}
              <a href={`mailto:${supportMail}`}>{supportMail}</a>
            </div>
          ),
        },
        {
          value: t(`${ns}Section1.Contents10.Title`),
          description: (
            <div>{t(`${ns}Section1.Contents10.Content.Description`)}</div>
          ),
        },
        {
          value: t(`${ns}Section1.Contents11.Title`),
          description: (
            <div>{t(`${ns}Section1.Contents11.Content.Description`)}</div>
          ),
        },
        {
          value: t(`${ns}Section1.Contents12.Title`),
          description: (
            <div>{t(`${ns}Section1.Contents12.Content.Description`)}</div>
          ),
        },
        // {
        //   value: t(`${ns}Section1.Contents13.Title`),
        //   description: (
        //     <div>{t(`${ns}Section1.Contents13.Content.Description`)}</div>
        //   ),
        // },
      ],
    },
    {
      title: t(`${ns}Section2.Title`),
      content: [
        {
          value: t(`${ns}Section2.Contents1.Title`),
          description: (
            <div id="studienanmeldung">
              {t(`${ns}Section2.Contents1.Content.Description`)}
            </div>
          ),
        },
        {
          value: t(`${ns}Section2.Contents2.Title`),
          description: (
            <span id="aufnahmegespräch" style={{ whiteSpace: 'pre-wrap' }}>
              {t(`${ns}Section2.Contents2.Content.Description`)}
            </span>
          ),
        },
        {
          value: t(`${ns}Section2.Contents3.Title`),
          description: (
            <span id="aufnahmefragebogen">
              {t(`${ns}Section2.Contents3.Content.Description`)}
            </span>
          ),
        },
        {
          value: t(`${ns}Section2.NewContents1.Title`),
          description: (
            <div
              id="zahlungsbereitschaftsstudie"
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {t(`${ns}Section2.NewContents1.Content.Description`)}
            </div>
          ),
        },
        {
          value: t(`${ns}Section2.NewContents2.Title`),
          description: (
            <div id="langzeitstudie" style={{ whiteSpace: 'pre-wrap' }}>
              {t(`${ns}Section2.NewContents2.Content.Description`)}
            </div>
          ),
        },
        {
          value: t(`${ns}Section2.Contents5.Title`),
          description: (
            <span id="verkaufsstart">
              {t(`${ns}Section2.Contents5.Content.Description`)}
            </span>
          ),
        },
        {
          value: t(`${ns}Section2.Contents6.Title`),
          description: (
            <span id="online-umfragen" style={{ whiteSpace: 'pre-wrap' }}>
              {t(`${ns}Section2.Contents6.Content.Description1`)}
            </span>
          ),
        },
      ],
    },
  ];
};

export default { getFullFaq };
